<template>
  <div>
    <div class="col-md-12 col-xl-12">
      <div class="card card-statistics">
        <div class="card-header">
          <h4 class="card-title">{{ $t("overView") }}</h4>
          <div class="d-flex justify-content-center">
            <div class="d-flex xet-width">
              <feather-icon icon="CalendarIcon" size="16" />
              <flat-pickr
                v-model="rangePicker"
                :config="config"
                class="
                  form-control
                  flat-picker
                  bg-transparent
                  border-0
                  shadow-none
                "
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>
        </div>
        <div class="card-body statistics-body">
          <div class="row">
            <div class="col-sm-6 col-xl-3 mb-2">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-danger rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="ShoppingCartIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <router-link
                    :to="{ name: 'my-wr1-quotation' }"
                    class="font-weight-bolder mb-0 h4"
                    >{{ totalQuotation | abbreviateNumber }}</router-link
                  >
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("quotation") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-warning rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="BoxIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <router-link
                    :to="{ name: 'my-wr1-booking' }"
                    class="font-weight-bolder mb-0 h4"
                    >{{ totalBooking | abbreviateNumber }}</router-link
                  >
                  <p class="card-text font-small-3 mb-0">{{ $t("booking") }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-primary rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="DollarSignIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <h4
                    @click="
                      () => {
                        $store.commit('tabView/SET_TAB_BOOKING', '9,11,999');
                        $router.push({ name: 'my-wr1-booking' });
                      }
                    "
                    class="font-weight-bolder mb-0 revenue"
                  >
                    {{ totalSumRevenue | abbreviateNumber }}
                  </h4>
                  <p class="card-text font-small-3 mb-0">{{ $t("revenue") }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-info rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="TruckIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <h4
                    @click="
                      () => {
                        $store.commit('tabView/SET_TAB_BOOKING', '8');
                        $router.push({ name: 'my-wr1-booking' });
                      }
                    "
                    class="font-weight-bolder mb-0 revenue"
                  >
                    {{ totalTransported | abbreviateNumber }}
                  </h4>
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("beingTransport") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pie -->
    <b-overlay
      variant="white"
      class="d-none"
      :show="loading"
      spinner-variant="primary"
      blur="0"
      style="height: 200px"
      opacity=".75"
      rounded="sm"
    >
      <div class="col-md-12 col-xl-12">
        <b-row>
          <!-- DONUT CHART -->
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="pieChartQuotation != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">
                    {{ $t("quotation") }}
                  </b-card-title>
                </div>
                <!--/ title and subtitle -->

                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>

              <vue-apex-charts
                :type="'pie'"
                height="350"
                :options="pieChartQuotation.chartOptions"
                :series="pieChartQuotation.series"
              ></vue-apex-charts>
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="pieChartBooking != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0"> {{ $t("booking") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->

                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'pie'"
                height="350"
                :options="pieChartBooking.chartOptions"
                :series="pieChartBooking.series"
              ></vue-apex-charts>
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="pieChartRevenue != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">{{ $t("revenue") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->

                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'pie'"
                height="350"
                :options="pieChartRevenue.chartOptions"
                :series="pieChartRevenue.series"
              ></vue-apex-charts>
            </b-card>
          </div>
        </b-row>
      </div>

      <div class="col-md-12 col-xl-12">
        <b-row>
          <!-- DONUT CHART -->
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartQuotationServ != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">
                    {{ $t("quotation") }}</b-card-title
                  >
                </div>
                <!--/ title and subtitle -->

                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>

              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartQuotationServ.chartOptions"
                :series="donutChartQuotationServ.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartBookingServ != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0"> {{ $t("booking") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->
                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>
                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartBookingServ.chartOptions"
                :series="donutChartBookingServ.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartRevenueServ != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">{{ $t("revenue") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->
                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartRevenueServ.chartOptions"
                :series="donutChartRevenueServ.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
        </b-row>
      </div>

      <!-- sale -->

      <div class="col-md-12 col-xl-12" v-if="userData.username == 'admin'">
        <b-row>
          <!-- DONUT CHART -->
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartQuotationSale != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">
                    {{ $t("quotation") }}</b-card-title
                  >
                </div>
                <!--/ title and subtitle -->

                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>

              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartQuotationSale.chartOptions"
                :series="donutChartQuotationSale.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartBookingSale != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0"> {{ $t("booking") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->
                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                </div>
                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartBookingSale.chartOptions"
                :series="donutChartBookingSale.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
          <div
            class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
            v-if="donutChartRevenueSale != null"
          >
            <b-card>
              <div class="justify-content-between">
                <!-- title and subtitle -->
                <div class="title-subtitle">
                  <b-card-title class="m-0">{{ $t("revenue") }}</b-card-title>
                </div>
                <!--/ title and subtitle -->
                <!-- datepicker -->
                <div class="d-flex justify-content-center">
                  <div class="d-flex xet-width">
                    <feather-icon icon="CalendarIcon" size="16" />
                    <flat-pickr
                      v-model="rangePicker"
                      :config="config"
                      class="
                        form-control
                        flat-picker
                        bg-transparent
                        border-0
                        shadow-none
                      "
                    />
                  </div>
                </div>

                <!-- datepicker -->
              </div>
              <vue-apex-charts
                :type="'donut'"
                height="350"
                :options="donutChartRevenueSale.chartOptions"
                :series="donutChartRevenueSale.series"
              ></vue-apex-charts>
              <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
            </b-card>
          </div>
        </b-row>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { Utils } from "@/@core/utils/utilsCustom";
import moment from "moment";

import { getUserData } from "@/auth/utils";
import {
  getMyWR1TotalOverView,
  getMyWR1TotalQuotationByComp,
  getMyWR1TotalBookingByComp,
  getMyWR1TotalRevenueByComp,
  getMyWR1TotalQuotationByServ,
  getMyWR1TotalBookingByServ,
  getMyWR1TotalRevenueByServ,
  getMyWR1TotalQuotationBySale,
  getMyWR1TotalBookingBySale,
  getMyWR1TotalRevenueBySale,
} from "@/api";

export default {
  components: {
    BRow,
    BCol,
    VueApexCharts,
  },
  data() {
    return {
      loading: true,
      totalQuotation: 0,
      totalBooking: 0,
      totalSumRevenue: 0,
      totalTransported: 0,
      userData: JSON.parse(localStorage.getItem("userData")),
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      rangePicker: ["2019-05-01", "2019-05-10"],

      pieChartQuotation: null,
      pieChartBooking: null,
      pieChartRevenue: null,
      donutChartQuotationServ: null,
      donutChartBookingServ: null,
      donutChartRevenueServ: null,
      donutChartQuotationSale: null,
      donutChartBookingSale: null,
      donutChartRevenueSale: null,
    };
  },
  watch: {
    rangePicker: function (newVal, oldVal) {
      if (newVal != oldVal) {
        const newDate = typeof newVal == "string" ? newVal.split(" ") : "";
        if (newDate) {
          const arr2 = newDate[2] ? newDate[2] : newDate[0];
          this.init(newDate[0], arr2);
        }
      }
    },
  },
  async created() {
    // data
    const { firstDay, lastDay } = Utils.getFirstAndLastDateOfCurrentMonth();

    this.rangePicker = [
      moment(String(firstDay)).format("YYYY/MM/DD"),
      moment(String(lastDay)).format("YYYY/MM/DD"),
    ];
    this.init(
      moment(String(firstDay)).format("YYYY/MM/DD"),
      moment(String(lastDay)).format("YYYY/MM/DD")
    );
  },
  mounted() {},
  methods: {
    track () {
      this.$gtag.pageview('Dashboard Wr1')
    },
    async init(firstDay, lastDay) {
      this.loading = true;
      const id = this.userData.username;

      getMyWR1TotalOverView({
        sale_id: id == "admin" ? "" : id,
        quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
        bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
        revenueStatus: Utils.CONSTANTS.STATUS_WR1.REVENUE,
        transportStatus: Utils.CONSTANTS.STATUS_WR1.TRANSPORT,
        startDate: this.formatDate(firstDay),
        endDate: this.rangePicker[1]
          ? this.formatDate(lastDay)
          : this.formatDate(firstDay),
      }).then((rs) => {
        if (rs) {
          this.totalSumRevenue = rs.totalRevenue;
          this.totalQuotation = rs.totalQuotation;
          this.totalBooking = rs.totalBooking;
          this.totalTransported = rs.totalTransported;
        }
      });

      const resultTotalQuotationByComp = await getMyWR1TotalQuotationByComp({
        quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
        startDate: this.formatDate(firstDay),
        endDate: this.rangePicker[1]
          ? this.formatDate(lastDay)
          : this.formatDate(firstDay),
      });

      const resultTotalBookingByComp = await getMyWR1TotalBookingByComp({
        bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
        startDate: this.formatDate(firstDay),
        endDate: lastDay ? this.formatDate(lastDay) : this.formatDate(firstDay),
      });

      const resultTotalRevenueByComp = Promise.resolve(
        getMyWR1TotalRevenueByComp({
          revenueStatus: Utils.CONSTANTS.STATUS_WR1.REVENUE,
          startDate: this.formatDate(firstDay),
          endDate: lastDay
            ? this.formatDate(lastDay)
            : this.formatDate(firstDay),
        })
      );

      // //service Quotation
      const resultTotalQuotationByServ = await getMyWR1TotalQuotationByServ({
        quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
        startDate: this.formatDate(firstDay),
        endDate: lastDay ? this.formatDate(lastDay) : this.formatDate(firstDay),
      });

      // //service Booking
      const resultWR1TotalBookingByServ = await getMyWR1TotalBookingByServ({
        bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
        startDate: this.formatDate(firstDay),
        endDate: lastDay ? this.formatDate(lastDay) : this.formatDate(firstDay),
      });

      // //service Revenue
      const resultWR1TotalRevenueByServ = await getMyWR1TotalRevenueByServ({
        revenueStatus: Utils.CONSTANTS.STATUS_WR1.REVENUE,
        startDate: this.formatDate(firstDay),
        endDate: lastDay ? this.formatDate(lastDay) : this.formatDate(firstDay),
      });

      var vm = this;
      Promise.all([
        resultTotalQuotationByComp,
        resultTotalBookingByComp,
        resultTotalRevenueByComp,
        resultTotalQuotationByServ,
        resultWR1TotalBookingByServ,
        resultWR1TotalRevenueByServ,
      ]).then((values) => {
        vm.pieChartQuotation = Utils.pieChart(
          Utils.formatCharts(values[0]).seriesArr,
          Utils.formatCharts(values[0]).categoriesArr
        );
        vm.pieChartBooking = Utils.pieChart(
          Utils.formatCharts(values[1]).seriesArr,
          Utils.formatCharts(values[1]).categoriesArr
        );
        vm.pieChartRevenue = Utils.pieChart(
          Utils.formatCharts(values[2]).seriesArr,
          Utils.formatCharts(values[2]).categoriesArr
        );
        vm.donutChartQuotationServ = Utils.donutChart(
          Utils.formatCharts(values[3]).seriesArr,
          Utils.formatCharts(values[3]).categoriesArr
        );
        vm.donutChartBookingServ = Utils.donutChart(
          Utils.formatCharts(values[4]).seriesArr,
          Utils.formatCharts(values[4]).categoriesArr
        );
        vm.donutChartRevenueServ = Utils.donutChart(
          Utils.formatCharts(values[5]).seriesArr,
          Utils.formatCharts(values[5]).categoriesArr
        );
      });

      if (this.userData.username == "admin") {
        //service Quotation
        const resultTotalQuotationBySale = await getMyWR1TotalQuotationBySale({
          quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
          startDate: this.formatDate(firstDay),
          endDate: lastDay
            ? this.formatDate(lastDay)
            : this.formatDate(firstDay),
        });

        const resultWR1TotalBookingBySale = await getMyWR1TotalBookingBySale({
          bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
          startDate: this.formatDate(firstDay),
          endDate: lastDay
            ? this.formatDate(lastDay)
            : this.formatDate(firstDay),
        });

        const resultWR1TotalRevenueBySale = Promise.resolve(
          getMyWR1TotalRevenueBySale({
            revenueStatus: Utils.CONSTANTS.STATUS_WR1.REVENUE,
            startDate: this.formatDate(firstDay),
            endDate: lastDay
              ? this.formatDate(lastDay)
              : this.formatDate(firstDay),
          })
        );
        Promise.all([
          resultTotalQuotationBySale,
          resultWR1TotalBookingBySale,
          resultWR1TotalRevenueBySale,
        ])
          .then((values) => {
            this.donutChartQuotationSale = Utils.donutChart(
              Utils.formatCharts(values[0]).seriesArr,
              Utils.formatCharts(values[0]).categoriesArr
            );
            this.donutChartBookingSale = Utils.donutChart(
              Utils.formatCharts(values[1]).seriesArr,
              Utils.formatCharts(values[1]).categoriesArr
            );
            this.donutChartRevenueSale = Utils.donutChart(
              Utils.formatCharts(values[2]).seriesArr,
              Utils.formatCharts(values[2]).categoriesArr
            );
          })
          .finally(() => (this.loading = false));
      }
    },
    formatDate(val) {
      return moment(String(val)).format("DD/MM/YYYY");
    },
  },
  filters: {
    abbreviateNumber: function (n) {
      if (n < 1e3) return n;
      if (n >= 1e3 && n < 1e6)    return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
      if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
      if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
<style >
input.form-control.flat-picker.bg-transparent.border-0.shadow-none.form-control.input {
  margin-top: -0.8rem;
}
.revenue {
  cursor: pointer;
}
.revenue:hover {
  color: #257f79;
}
.title-subtitle {
  text-align: center;
  padding-bottom: 5px;
}
</style>
